export default __webpack_public_path__ + "static/media/bh5.7a599542.jpg";